import React, { useState, useEffect } from 'react';
import { Box, Tab, Tabs, styled, Button } from '@mui/material';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { auth, db } from '../firebase'; // Import the Firebase authentication and database instances
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import ChangeCircleRoundedIcon from '@mui/icons-material/ChangeCircleRounded';

// Define CustomTabs and CustomTab based on the styling provided in your Home component
const CustomTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: '#FFFFFF',
  },
});

const CustomTab = styled((props) => <Tab {...props} />)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 0,
  [theme.breakpoints.up('sm')]: {
    minWidth: 0,
  },
  fontWeight: theme.typography.fontWeightRegular,
  marginRight: theme.spacing(1),
  fontFamily: theme.typography.fontFamily,
  '&.Mui-selected': {
    color: '#000',
    backgroundColor: '#F5F5F5',
    borderRadius: '10px',
    fontWeight: theme.typography.fontWeightBold,
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(255, 76, 21, 0.32)',
  },
}));

const AccountSettings = () => {
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState({ email: '', firstName: '', lastName: '' });
  const printfulOAuthRedirect = process.env.REACT_APP_PRINTFUL_OAUTH_REDIRECT;
  const redirectToPrintfulOAuth = () => {
    window.location.href = printfulOAuthRedirect;
  }

  const handleSignOut = async () => {
    try {
      await auth.signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error.message);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (user) {
        const userRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          setUserDetails({
            email: user.email, // Assuming email is directly accessible from the auth user object
            firstName: userDoc.data().firstName,
            lastName: userDoc.data().lastName,
          });
        } else {
          console.log("No user data found in Firestore");
        }
      }
    };

    fetchUserData();
  }, []);

  return (
    <div>
      <h1>Account</h1>
      <p>Manage your account information and preferences.</p>

      <Box sx={{ marginBottom: '50px' }}>
        <Box
          sx={{
            padding: 2,
            borderRadius: '10px',
            bgcolor: '#F5F5F5',
            marginBottom: '20px',
          }}
        >
          <p>Email: {userDetails.email}</p>
        </Box>

        <Box
          sx={{
            padding: 2,
            borderRadius: '10px',
            bgcolor: '#F5F5F5',
            marginBottom: '20px',
          }}
        >
          <p>First Name: {userDetails.firstName}</p>
        </Box>

        <Box
          sx={{
            padding: 2,
            borderRadius: '10px',
            bgcolor: '#F5F5F5',
          }}
        >
          <p>Last Name: {userDetails.lastName}</p>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingTop: 2,
          width: '400px',
        }}
      >
        <Button
          onClick = {redirectToPrintfulOAuth}
          sx={{
            backgroundColor: '#FFFFFF',
            '&:hover': { backgroundColor: '#F5F5F5' },
            color: '#ff4c15',
            borderRadius: '10px',
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            marginRight: '50px', // Add padding to separate text and end icon
            paddingRight: '20px',
          }}
          
          startIcon={<ChangeCircleRoundedIcon />}
        >
          Change Printful Store
        </Button>

        <Button
          aria-label="sign out"
          onClick={handleSignOut}
          sx={{
            minWidth: '80px',
            backgroundColor: 'transparent',
            color: '#ff4c15ff',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
            borderRadius: '10px',
            padding: '10px',
            height: '100%',
          }}
          startIcon={<LogoutRoundedIcon />}
        >
          Logout
        </Button>
      </Box>
    </div>
  );
};

const BillingSettings = () => (
  <div>
    <h1>Billing</h1>
    <p>Coming soon...</p>
  </div>
);

function Settings() {
  const [value, setValue] = useState('account');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <CustomTabs value={value} onChange={handleChange} textColor="inherit" aria-label="settings tabs">
        <CustomTab value="account" label="Account" />
        <CustomTab value="billing" label="Billing" />
      </CustomTabs>
      {(() => {
        switch (value) {
          case 'account':
            return <AccountSettings />;
          case 'billing':
            return <BillingSettings />;
          default:
            return <p>Content goes here...</p>;
        }
      })()}
    </Box>
  );
}

export default Settings;
